<template>
  <div>
        <div class="data-list-container" v-if="flag">
            <!-- strat Addresses -->
            <div class="con-vs-card" :class="{'border': Addresses[Address].is_default == 1}" card-background="red" v-for="(Item,Address) in Addresses" :key="Address">
                <div class="vs-card--content">
                    <div class="flex items-center">
                      <div class="p-4 flex-1" style="width: calc(100% - 92px)">
                          <div><span>{{Addresses[Address].province}} , {{Addresses[Address].city}}</span></div>
                          <h5 class="text-ellipis">
                              {{Addresses[Address].address}}
                          </h5>
                      </div>
                      <div class="flex justify-content-end" style="width: 92px">
                        <vs-tooltip text="پیشفرض">
                          <svg @click="Check_Index(Address)" v-if="Addresses[Address].is_default == 0"
                              viewBox="0 0 24 24" class="cursor-pointer" style="width: 24px; height: 24px; margin-left: 10px;">
                              <path fill="green" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"></path>
                          </svg>
                          <svg v-else viewBox="0 0 24 24" class="cursor-pointer" style="width: 24px; height: 24px; margin-left: 10px;">
                            <path d="M6 12v9a1 1 0 0 1-2 0V4c0-1.1.9-2 2-2h6c1.1 0 1.999.9 1.999 2H18a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-5a2 2 0 0 1-1.997-2H6zm0-8v6h7v2h5.002V6H12V4H6z" fill="green" fill-rule="evenodd"></path>
                          </svg>
                        </vs-tooltip>
                        <vs-tooltip text="ویرایش">
                          <svg @click="Open_Editing_Modal(Address)" viewBox="0 0 24 24" class="modal-trigger cursor-pointer" style="width: 24px; height: 24px; margin-left: 10px;">
                              <path fill="#dd8b1a" d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"></path>
                          </svg>
                        </vs-tooltip>
                        <vs-tooltip text="حذف">
                          <svg @click="deleteAddress(Address)" viewBox="0 0 24 24" class="cursor-pointer" style="width: 24px; height: 24px;">
                            <path data-v-3eb0289e="" fill="rgba(255,0,0,0.7)" d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"></path>
                          </svg>
                        </vs-tooltip>
                      </div>
                    </div>
                </div>
            </div>
            <!-- end Addresses -->
            <div class="flex items-center justify-center">
                <button class="btn-custom secondary" @click="model = true">افزودن  آدرس جدید</button>
            </div>
        </div>

        <modal v-model="model" @close="clear">
            <template v-slot:header>
                {{ (Edit == false)?"افزودن آدرس جدید":"ویرایش آدرس" }}
            </template>
            <template v-slot:body>
              <form @submit.prevent="beforeAdd_Address">
                <div class="row">
                  <div class="col-lg-4 form-group">
                    <label>نام و نام خانوادگی دریافت کننده</label>
                    <input v-model="Form_Data.reciver_fname" type="text" class="form-control" placeholder="نام و نام خانوادگی دریافت کننده" v-validate="{required: true, fa: true}" name="fullname">
                    <div class="text-danger text-sm" v-for="error in errors.collect('fullname')" :key="error">{{ error }}</div>
                  </div>
                  <div class="col-lg-4 form-group">
                    <label>استان</label>
                    <input v-model="Form_Data.province" type="text" class="form-control" placeholder="استان" v-validate="{required: true, fa: true}" name="state">
                    <div class="text-danger text-sm" v-for="error in errors.collect('state')" :key="error">{{ error }}</div>
                  </div>
                  <div class="col-lg-4 form-group">
                    <label>شهر</label>
                    <input v-model="Form_Data.city" type="text" class="form-control" placeholder="شهر" v-validate="{required: true, fa: true}" name="city">
                    <div class="text-danger text-sm" v-for="error in errors.collect('city')" :key="error">{{ error }}</div>
                  </div>
                  <div class="col-lg-4 form-group">
                    <label>کد پستی</label>
                    <input v-model="Form_Data.zipcode" type="Phone" class="form-control" placeholder=" xxxxxxxxxx " v-validate="{required: true, numeric: true,min:10,max:10}" name="zip"  @keypress="onlyNumber">
                    <div class="text-danger text-sm" v-for="error in errors.collect('zip')" :key="error">{{ error }}</div>
                  </div>
                  <div class="col-lg-4 form-group">
                    <label>شماره تلفن همراه</label>
                    <input v-model="Form_Data.reciver_phone" type="text" class="form-control" placeholder=" 09xxxxxxxxx " v-validate="{required: true, mobile: true}" name="mobile"  @keypress="onlyNumber">
                    <div class="text-danger text-sm" v-for="error in errors.collect('mobile')" :key="error">{{ error }}</div>
                  </div>
                  <div class="col-lg-4 form-group">
                    <label> تلفن ثابت</label>
                    <input v-model="Form_Data.reciver_fixed_phone" type="text" class="form-control" placeholder=" 0x1xxxxxxx " v-validate="{required: true, phone: true}" name="phone"  @keypress="onlyNumber">
                    <div class="text-danger text-sm" v-for="error in errors.collect('phone')" :key="error">{{ error }}</div>
                  </div>
                  <div class="col-md-12 form-group">
                    <label>آدرس</label>
                    <textarea v-model="Form_Data.address" class="form-control" placeholder="آدرس کامل" rows="4" v-validate="{required: true}" name="address"/>
                    <div class="text-danger text-sm" v-for="error in errors.collect('address')" :key="error">{{ error }}</div>
                  </div>
                </div>
                <!-- start Submits -->
                <!-- save -->
                <div v-if="Edit === false" class="flex items-center justify-center">
                    <button @click.prevent="beforeAdd_Address" class="btn-custom secondary"> ثبت آدرس </button>
                </div>
                <!-- edit -->
                <div v-else class="flex items-center justify-center">
                    <button @click.prevent="beforeAdd_Address" class="btn-custom secondary"> ویرایش </button>
                </div>
              </form>
                <!-- end Submits -->
            </template>
        </modal>
    </div>
</template>

<script>
import axios from '@/plugins/axios'
import modal from "@/components/modal";
// import login from "../../components/layouts/login";
export default {
    props:{
        togglePreLoader:Function
    },
    components: {modal},
    data () {
        return {
          Addresses: [],
          Address_Id: 0,
          Form_Data: {
            reciver_fname: null,
            province: null,
            city: null,
            address: null,
            reciver_phone: null,
            reciver_fixed_phone: null,
            zipcode: null,
            is_default: 0,
            new: null
          },
          id: null,
          user_id_id: null,
          Data: null,
          Edit: false,
          model: false,
          flag:false
        }
    },
    methods: {
      onlyNumber ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57)) { // 46 is dot
          $event.preventDefault();
        }
      },
        clear(){
          console.log("close")
            this.Form_Data = {
              reciver_fname: null,
              province: null,
              city: null,
              address: null,
              reciver_phone: null,
              reciver_fixed_phone: null,
              zipcode: null,
              is_default: 1,
              new: null
            }
        },
        Check_Index (Index) {
            this.Address_Id = this.Addresses[Index].id
            this.Set_Default()
        },
        Open_Editing_Modal (Index) {
            this.Edit = true
            this.Address_Id = Index
            this.Form_Data = this.Addresses[Index]
            this.model = true
        },
        async Get_Addresses () {
            try {
                this.togglePreLoader('open')
                let {data} = await axios.get(`/cu/address`)
                this.Addresses = data
                this.Notif_Title = null
                this.Notif_Icon = null
                this.Notif_Text = null
                this.Notif_Color = null
            }catch (error) {
              if (error.response && error.response.data.errors) {
                let str_error = ''
                for(let item of Object.values(error.response.data.errors))
                {
                  item.map(xx=>{
                    if (xx.includes("shipping address")){
                      str_error += xx.replace("shipping address","آدرس") + "<br/>"
                    }
                    else{
                      str_error += xx + "<br/>"
                    }
                  })
                }
                this.$vs.notify({title:'خطایی رخ داد',time:3500,text:str_error,color:'var(--secondary-color)',icon:'error_outline'})
              }
              else{
                if (error) {
                  if(error == "Error: Network Error"){
                    this.$vs.notify({title:'خطایی رخ داد',time:3500,text:"اتصال برقرار نشد",color:'var(--secondary-color)',icon:'error_outline'})
                  }
                  else {
                    this.$vs.notify({title:'خطایی رخ داد',time:3500,text:error,color:'var(--secondary-color)',icon:'error_outline'})
                  }
                }
              }
            }finally {
                this.togglePreLoader('close')
            }
        },
        async Set_Default () {
            try {
                this.togglePreLoader('open')
                let {data} = await axios({
                    method: 'post',
                    url: `/cu/set-default`,
                    headers:{},
                    data: {id: this.Address_Id}
                })
                this.Data = data
                this.Notif_Title = null
                this.Notif_Icon = 'check'
                this.Notif_Text = 'اطلاعات با موفقیت ویرایش شد'
                this.Notif_Color = 'var(--secondary-color)'
                this.$vs.notify({title:this.Notif_Title,time:3500,text:this.Notif_Text,color:this.Notif_Color,icon:this.Notif_Icon})
                this.Get_Addresses()
            }catch (error) {
              if (error.response && error.response.data.errors) {
                let str_error = ''
                for(let item of Object.values(error.response.data.errors))
                {
                  item.map(xx=>{
                    if (xx.includes("shipping address")){
                      str_error += xx.replace("shipping address","آدرس") + "<br/>"
                    }
                    else{
                      str_error += xx + "<br/>"
                    }
                  })
                }
                this.$vs.notify({title:'خطایی رخ داد',time:3500,text:str_error,color:'var(--secondary-color)',icon:'error_outline'})
              }
              else{
                if (error) {
                  if(error == "Error: Network Error"){
                    this.$vs.notify({title:'خطایی رخ داد',time:3500,text:"اتصال برقرار نشد",color:'var(--secondary-color)',icon:'error_outline'})
                  }
                  else {
                    this.$vs.notify({title:'خطایی رخ داد',time:3500,text:error,color:'var(--secondary-color)',icon:'error_outline'})
                  }
                }
              }
            }finally {
                this.togglePreLoader('close')
            }
        },
        beforeAdd_Address(){
          this.$validator.validateAll().then((result) => {
            if (result) {
              if(this.Edit) this.Edit_Address()
              else this.Add_Address()
              return;
            }

            this.$vs.notify({
              title: 'خطا',
              text: "مقادیر ورودی نا معتبراست",
              color: 'danger'})
          });
      },
        async Edit_Address () {
          try {
            this.togglePreLoader('open')
            let {data} = await axios ({
                method: 'put',
                url:`/cu/address/${this.Form_Data.id}`,
                headers: {},
                data: this.Form_Data
            })
            this.Data = data
            // console.log(false)
            this.model = false
            this.$vs.notify({time:3500,text:'اطلاعات با موفقیت ویرایش شد',color:'var(--secondary-color)',icon:'check'})
            this.Get_Addresses()
            this.Edit = false
          }
          catch (error) {
            if (error.response && error.response.data.errors) {
              let str_error = ''
              for(let item of Object.values(error.response.data.errors))
              {
                item.map(xx=>{
                  if (xx.includes("shipping address")){
                    str_error += xx.replace("shipping address","آدرس") + "<br/>"
                  }
                  else{
                    str_error += xx + "<br/>"
                  }
                })
              }
              this.$vs.notify({title:'خطایی رخ داد',time:3500,text:str_error,color:'var(--secondary-color)',icon:'error_outline'})
            }
            else{
              if (error) {
                if(error == "Error: Network Error"){
                  this.$vs.notify({title:'خطایی رخ داد',time:3500,text:"اتصال برقرار نشد",color:'var(--secondary-color)',icon:'error_outline'})
                }
                else {
                  this.$vs.notify({title:'خطایی رخ داد',time:3500,text:error,color:'var(--secondary-color)',icon:'error_outline'})
                }
              }
            }
          }finally {
              this.togglePreLoader('close')
          }
        },
        async Add_Address () {
          try {
              this.togglePreLoader('open')
              let {data} = await axios ({
                  method: 'post',
                  url:`/cu/address`,
                  headers: {},
                  data: this.Form_Data
              })
              this.Data = data
              this.model = false
              this.Get_Addresses()
              this.$vs.notify({time:3500,text:'آدرس با موفقیت ویرایش شد',color:'var(--secondary-color)',icon:'check'})
          } catch (error) {
            if (error.response && error.response.data.errors) {
              let str_error = ''
              for(let item of Object.values(error.response.data.errors))
              {
                item.map(xx=>{
                  if (xx.includes("shipping address")){
                    str_error += xx.replace("shipping address","آدرس") + "<br/>"
                  }
                  else{
                    str_error += xx + "<br/>"
                  }
                })
              }
              this.$vs.notify({title:'خطایی رخ داد',time:3500,text:str_error,color:'var(--secondary-color)',icon:'error_outline'})
            }
            else{
              if (error) {
                if(error == "Error: Network Error"){
                  this.$vs.notify({title:'خطایی رخ داد',time:3500,text:"اتصال برقرار نشد",color:'var(--secondary-color)',icon:'error_outline'})
                }
                else {
                  this.$vs.notify({title:'خطایی رخ داد',time:3500,text:error,color:'var(--secondary-color)',icon:'error_outline'})
                }
              }
            }
          }finally {
              this.togglePreLoader('close')
          }
        },
        async deleteAddress(Index) {
        this.togglePreLoader('open')
        await axios.delete(`cu/address/${this.Addresses[Index].id}`)
            .then((response) => {
              this.Data = response
              this.Get_Addresses()
              this.$vs.notify({time:3500,text:"آدرس با موفقیت حذف شد",color:'var(--secondary-color)',icon:'check'})
            })
            .catch((error)=>{
              if (error.response && error.response.data) {
                let str_error = error.response.data.message
                this.$vs.notify({title:'خطایی رخ داد',time:3500,text:str_error,color:'var(--secondary-color)',icon:'error_outline'})
              }
              else {
                if(error == "Error: Network Error"){
                  this.$vs.notify({title:'خطایی رخ داد',time:3500,text:"اتصال برقرار نشد",color:'var(--secondary-color)',icon:'error_outline'})
                }
                else {
                  this.$vs.notify({title:'خطایی رخ داد',time:3500,text:error,color:'var(--secondary-color)',icon:'error_outline'})
                }
              }
            })
        this.togglePreLoader('close')

      }
    },
    async created () {
      await this.Get_Addresses()
      this.flag = true
    }
}
</script>
